@if (entity) {
  <div
    class="home-entity-row"
    [ngClass]="{
      'row-hidden': entity.hidden
    }"
  >
    <div class="home-entity-row-icon">
      <i
        class="fas fa-link pointer"
        [title]="'entity-redirection' | translate"
        (click)="goToEntity($event, entity)"
        (contextmenu)="goToEntity($event, entity, true)"
      ></i>
    </div>
    <div class="home-entity-row-icon">
      <input
        type="checkbox"
        name="entity-visibility"
        class="pointer"
        [(ngModel)]="entity.show"
        (click)="entity.show = !entity.show; showEntity.emit()"
      />
    </div>
    <div
      class="home-entity-row-title pointer"
      (click)="entity.show = !entity.show; showEntity.emit()"
    >
      {{ entity.entity.toUpperCase() }}
    </div>
    <div class="home-entity-row-alarms">
      {{ entity.totalAlarms ? formatNumber(entity.totalAlarms, numberFormat) : "-" }}
      <i class="fas fa-triangle-exclamation"></i>
    </div>
    <div class="home-entity-row-totals">
      {{ formatNumber(entity.devicesTotal, numberFormat) }}
      <i class="fas fa-tachometer-alt"></i>
    </div>
    <div class="home-entity-row-graph">
      <app-graph-controller
        [highchartsOptions]="deviceTotalsHighchartsOptions"
        [noOptionsParse]="true"
        [onlyGraph]="true"
        [disableShowPoints]="true"
        [data]="entity.deviceTotalsChartOptions"
      ></app-graph-controller>
    </div>
  </div>
}
